import { saveTerraiAnalysys } from '../lib/userPreferences'

export default {
  namespace: 'terrain',
  state: {
    preferences: {
      terrainAnalysis: {
        aspect: [1, 2, 8, 9],
        elevation: [100, 14400],
        enabled: false,
        opacity: 0.5,
        slope: [1, 2, 3, 4, 5]
      }
    }
  },

  effects: {},

  reducers: {
    setDefaultFilters(state) {
      const { preferences } = state
      const data = { jobs: [] }
      preferences.terrainAnalysis = {
        ...preferences.terrainAnalysis,
        aspect: [1, 2, 8, 9],
        elevation: [100, 14400],
        opacity: 0.5,
        slope: [1, 2, 3, 4, 5],
      }
      data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setEnabledStatus(state, { payload }) {
      const { preferences } = state
      // const data = { jobs: [] }
      preferences.terrainAnalysis.enabled = payload
      /* 
        No need to update user preferences on the backend since the Terrain Analysis tool
        is not enabled on application start. Updating local state wmust continue.
      */
      // data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      // saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setElevationValues(state, { payload }) {
      const { preferences } = state
      const data = { jobs: [] }
      preferences.terrainAnalysis.elevation = payload
      data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setSlopeValues(state, { payload }) {
      const { preferences } = state
      const data = { jobs: [] }
      preferences.terrainAnalysis.slope = payload
      data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setAspectValues(state, { payload }) {
      const { preferences } = state
      const data = { jobs: [] }
      preferences.terrainAnalysis.aspect = payload
      data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setOpacityValue(state, { payload }) {
      const { preferences } = state
      const data = { jobs: [] }
      preferences.terrainAnalysis.opacity = payload
      data.jobs = [{ action: 'change', path: 'global/terrainAnalysis', values: [preferences.terrainAnalysis]}]
      saveTerraiAnalysys(data)
      return {
        ...state
      };
    },
    setAllPreferences(state, { payload }) {
      state.preferences.terrainAnalysis = payload
			return {
				...state
			}
    },
  }
};
